// extracted by mini-css-extract-plugin
export default {"wrapperBody":"DatasetTaggingBodyWrapper__wrapperBody___rwIvD"};